import React, { useEffect, useRef } from 'react';
import Snow from './free-icon-snowflake-95941.svg';
import styles from './snowComponent.css';


const SnowComponent = () => {
    const snowWrapper = useRef();
// Amount of Snowflakes
    const snowMax = 35;
// Snowflake Colours
    const snowColor = [ '#DDD', '#EEE' ];
// Falling Velocity
    const snowSpeed = 0.75;
// Minimum Flake Size
    const snowMinSize = 8;
// Maximum Flake Size
    const snowMaxSize = 24;
// Refresh Rate (in milliseconds)
    const snowRefresh = 50;
// Additional Styles
    const snowStyles = {
        cursor: 'default',
        '-webkit-user-select': 'none',
        '-moz-user-select': 'none',
        '-ms-user-select': 'none',
        '-o-user-select': 'none',
        'user-select': 'none'
    };

    let snow = [], pos = [], coords = [], lefr = [], marginBottom, marginRight;

    useEffect( () => {
        window.addEventListener( 'resize', resize );
        initSnow();
    }, [] );

    const randomise = ( range ) => {
        return Math.floor( range * Math.random() );
    };

    const initSnow = () => {
        let snowSize = snowMaxSize - snowMinSize;
        marginBottom = snowWrapper.current.scrollHeight - 5;
        marginRight = snowWrapper.current.clientWidth - 15;

        for ( let i = 0 ; i <= snowMax ; i++ ) {
            coords[ i ] = 0;
            lefr[ i ] = Math.random() * 15;
            pos[ i ] = 0.03 + Math.random() / 10;
            snow[ i ] = document.getElementById( 'flake' + i );
            snow[ i ].style.fontFamily = 'inherit';
            snow[ i ].size = randomise( snowSize ) + snowMinSize;
            snow[ i ].style.fontSize = snow[ i ].size + 'px';
            snow[ i ].style.height = snow[ i ].size + 'px';
            snow[ i ].style.width = snow[ i ].size + 'px';
            snow[ i ].style.color = snowColor[ randomise( snowColor.length ) ];
            snow[ i ].style.zIndex = 1000;
            snow[ i ].sink = snowSpeed * snow[ i ].size / 5;
            snow[ i ].posX = randomise( marginRight - snow[ i ].size );
            snow[ i ].posY = randomise( 2 * marginBottom - marginBottom - 2 * snow[ i ].size );
            snow[ i ].style.left = snow[ i ].posX + 'px';
            snow[ i ].style.top = snow[ i ].posY + 'px';
        }

        moveSnow();
    };

    const resize = () => {
        marginBottom = snowWrapper.current.scrollHeight - 5;
        marginRight = snowWrapper.current.clientWidth - 15;
    };

    const moveSnow = () => {
        for ( let i = 0 ; i <= snowMax ; i++ ) {
            coords[ i ] += pos[ i ];
            snow[ i ].posY += snow[ i ].sink;
            snow[ i ].style.left = snow[ i ].posX + lefr[ i ] * Math.sin( coords[ i ] ) + 'px';
            snow[ i ].style.top = snow[ i ].posY + 'px';

            if ( snow[ i ].posY >= marginBottom - 2 * snow[ i ].size || parseInt( snow[ i ].style.left ) > ( marginRight - 3 * lefr[ i ] ) ) {
                snow[ i ].posX = randomise( marginRight - snow[ i ].size );
                snow[ i ].posY = 0;
            }
        }

        setTimeout( moveSnow, snowRefresh );
    };

    const getSwnows = () => {
        let snowArr = [];

        for ( let i = 0 ; i <= snowMax ; i++ ) {
            snowArr.push( <span
                key={ i }
                id={ `flake${ i }` }
                style={ { ...snowStyles, position: 'absolute', top: `-${ snowMaxSize }` } }>
                <Snow/>
                </span>
            );
        }
        return snowArr.map( ( elm ) => elm );
    };


    return (
        <div className={ styles.wrapper } ref={ snowWrapper }>
            { getSwnows() }
        </div> );

};


export default SnowComponent;